import React, { Fragment, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import estilos from './Documentacion.module.css'
import { v4 as uuidv4 } from 'uuid';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import { obtenerTodoHistorialCliente } from '../../../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import BotonVerArchivosComponent from './BotonesComponent/BotonVerArchivosComponent';
import BotonHistorialComponent from './BotonesComponent/BotonHistorialComponent';
import BotonSustituirComponent from './BotonesComponent/BotonSustituirComponent';
import BotonDocumentoValidoComponent from './BotonesComponent/BotonDocumentoValidoComponent';

function DocumentacionGeneralComponent(props) {
    let detalleCliente = props?.detalle
    const usuarioCompleto = useSelector(store => store.Usuario.user)
    const fechaHoy = moment().format('YYYY-MM-DD')

    let rowsDocumentacionGeneral = []
    let rowsDocumentacionApoderadosLegales = []
    let rowsDocumentacionPersonasAutorizadas = []
    let rowsDocumentacionArchivosGenerales = []

    const dispatch = useDispatch()

    //Documentación general
    for (const i in detalleCliente.archivosgeneralescliente) {

        let alertaFechaVencimiento = ''
        let diasFaltantesVencimiento
        let nameDoc = ''

        if (detalleCliente.archivosgeneralescliente[i].nameid === "DGAC") nameDoc = 'Acta constitutiva notariada'
        if (detalleCliente.archivosgeneralescliente[i].nameid === "DGPN") nameDoc = 'Poder notarial del representante legal o última acta de asamblea notariada.'
        if (detalleCliente.archivosgeneralescliente[i].nameid === "DGIOVREP") nameDoc = 'Identificación oficial vigente del representante legal: ' + detalleCliente.nombrerepresentantelegal
        if (nameDoc.length > 0) {

            if (detalleCliente?.archivosgeneralescliente?.[i]?.fechafin !== null) {

                diasFaltantesVencimiento = moment(detalleCliente?.archivosgeneralescliente?.[i]?.fechafin.substring(0, 10)).diff(moment(fechaHoy), 'days')

                if (diasFaltantesVencimiento > 5) {
                    alertaFechaVencimiento = 'verde'
                } else if (diasFaltantesVencimiento > 0 && diasFaltantesVencimiento < 6) {
                    alertaFechaVencimiento = 'amarillo'
                } else if (diasFaltantesVencimiento == 0 || diasFaltantesVencimiento < 0) {
                    alertaFechaVencimiento = 'rojo'
                }
            } else {
                alertaFechaVencimiento = 'gris'
            }

            rowsDocumentacionGeneral.push({
                id: uuidv4(),
                observacion: detalleCliente?.archivosgeneralescliente?.[i]?.observaciones,
                fechaInicio: detalleCliente?.archivosgeneralescliente?.[i]?.fechainicio !== null ? detalleCliente?.archivosgeneralescliente?.[i]?.fechainicio.substring(0, 10) : '---',
                fechaTermino: detalleCliente?.archivosgeneralescliente?.[i]?.fechafin !== null ? detalleCliente?.archivosgeneralescliente?.[i]?.fechafin.substring(0, 10) : '---',
                estatus: detalleCliente?.archivosgeneralescliente?.[i]?.estatus !== 'null' ? detalleCliente?.archivosgeneralescliente?.[i]?.fechafin : 'Agregar',
                tabla: 'archivosgeneralescliente', nombreId: 'idarchivosgeneralescliente',
                idSolicitud: detalleCliente.archivosgeneralescliente[i].idarchivosgeneralescliente, nameid: detalleCliente?.archivosgeneralescliente?.[i]?.nameid,
                nameDoc: nameDoc, colorAlertaFecha: alertaFechaVencimiento, quitarVigencia: false,
                isDocumentoValido: detalleCliente?.archivosgeneralescliente?.[i]?.isdocumentovalido
            })
        }
    }

    if (rowsDocumentacionGeneral.length > 1) {
        rowsDocumentacionGeneral.sort(((a, b) => a.idSolicitud - b.idSolicitud));
    }

    //Apoderados legales
    for (const a in detalleCliente.apoderadoslegalescliente) {
        if (rowsDocumentacionApoderadosLegales.includes(detalleCliente?.apoderadoslegalescliente?.[a]?.representantelegal) == false) {
            rowsDocumentacionApoderadosLegales.push({ id: uuidv4(), nameDoc: (detalleCliente?.apoderadoslegalescliente?.[a]?.representantelegal).toUpperCase() })
        }
        for (const b in detalleCliente.apoderadoslegalescliente[a].archivosapoderadoslegalescliente) {

            let alertaFechaVencimiento = ''
            let diasFaltantesVencimiento
            let nameDoc = ''

            if ((detalleCliente.apoderadoslegalescliente[a].archivosapoderadoslegalescliente[b].nameid).includes('DGIOVAP')) nameDoc = 'Identificación oficial vigente'
            else if ((detalleCliente.apoderadoslegalescliente[a].archivosapoderadoslegalescliente[b].nameid).includes('DGPNAP')) nameDoc = 'Poder notarial'

            if (nameDoc.length > 0) {

                if (detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.fechafin !== null) {

                    diasFaltantesVencimiento = moment(detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.fechafin.substring(0, 10)).diff(moment(fechaHoy), 'days')

                    if (diasFaltantesVencimiento > 5) {
                        alertaFechaVencimiento = 'verde'
                    } else if (diasFaltantesVencimiento > 0 && diasFaltantesVencimiento < 6) {
                        alertaFechaVencimiento = 'amarillo'
                    } else if (diasFaltantesVencimiento == 0 || diasFaltantesVencimiento < 0) {
                        alertaFechaVencimiento = 'rojo'
                    }
                } else {
                    alertaFechaVencimiento = 'gris'
                }

                rowsDocumentacionApoderadosLegales.push({
                    id: uuidv4(),
                    observacion: detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.observaciones,
                    fechaInicio: detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.fechainicio !== null ? detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.fechainicio.substring(0, 10) : '---',
                    fechaTermino: detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.fechafin !== null ? detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.fechafin.substring(0, 10) : '---',
                    estatus: detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.estatus !== null ? detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.estatus : 'Agregar',
                    tabla: 'archivosapoderadoslegalescliente',
                    nombreId: 'idapoderadoslegales',
                    idSolicitud: detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.idapoderadoslegales,
                    nameid: detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.nameid,
                    nameDoc: nameDoc, /* + ' del apoderado legal ' + detalleCliente?.apoderadoslegalescliente?.[a]?.representantelegal, */
                    idAnexo: detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.idarchivosapoderadoscliente,
                    colorAlertaFecha: alertaFechaVencimiento, quitarVigencia: false,
                    isDocumentoValido: detalleCliente?.apoderadoslegalescliente?.[a]?.archivosapoderadoslegalescliente?.[b]?.isdocumentovalido
                })
            }
        }
    }

    //Personas autorizadas
    for (const a in detalleCliente.representantesautorizadoscliente) {
        if (rowsDocumentacionPersonasAutorizadas.includes(detalleCliente.representantesautorizadoscliente[a].personaautoriazadaparatramites) == false) {
            rowsDocumentacionPersonasAutorizadas.push({ id: uuidv4(), nameDoc: (detalleCliente.representantesautorizadoscliente[a].personaautoriazadaparatramites).toUpperCase() })
        }
        for (const b in detalleCliente.representantesautorizadoscliente[a].archivospersonasautorizadascliente) {

            let alertaFechaVencimiento = ''
            let diasFaltantesVencimiento

            if (detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.fechafin !== null) {

                diasFaltantesVencimiento = moment(detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.fechafin.substring(0, 10)).diff(moment(fechaHoy), 'days')

                if (diasFaltantesVencimiento > 5) {
                    alertaFechaVencimiento = 'verde'
                } else if (diasFaltantesVencimiento > 0 && diasFaltantesVencimiento < 6) {
                    alertaFechaVencimiento = 'amarillo'
                } else if (diasFaltantesVencimiento == 0 || diasFaltantesVencimiento < 0) {
                    alertaFechaVencimiento = 'rojo'
                }
            } else {
                alertaFechaVencimiento = 'gris'
            }

            rowsDocumentacionPersonasAutorizadas.push({
                id: uuidv4(),
                observacion: detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.observaciones,
                fechaInicio: detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.fechainicio !== null ? detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.fechainicio.substring(0, 10) : '---',
                fechaTermino: detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.fechafin !== null ? detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.fechafin.substring(0, 10) : '---',
                estatus: detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.estatus !== null ? detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.estatus : 'Agregar',
                tabla: 'archivospersonasautorizadascliente',
                nombreId: 'idrepresentantesautorizados',
                idSolicitud: detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.idrepresentantesautorizados,
                nameid: detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.nameid,
                nameDoc: 'Identificación oficial vigente', /* de la persona autorizada: ' + detalleCliente.representantesautorizadoscliente[a].personaautoriazadaparatramites, */
                idAnexo: detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.idarchivospersonasatutorizadascliente,
                colorAlertaFecha: alertaFechaVencimiento, quitarVigencia: false,
                isDocumentoValido: detalleCliente?.representantesautorizadoscliente?.[a]?.archivospersonasautorizadascliente?.[b]?.isdocumentovalido
            })
        }
    }

    //archivos generales
    for (const i in detalleCliente.archivosgeneralescliente) {

        let alertaFechaVencimiento = ''
        let diasFaltantesVencimiento
        let nameDoc = ''
        let quitarVigencia = false

        //if (detalleCliente.archivosgeneralescliente[i].nameid === "DGCDF") nameDoc = 'Comprobante de domicilio Fiscal.'
        if (detalleCliente.archivosgeneralescliente[i].nameid === "DGRFC") nameDoc = 'Constancia de situación fiscal (RFC).'
        if (detalleCliente.archivosgeneralescliente[i].nameid === "DGC") nameDoc = 'Documento que acredite su certificación: ' + detalleCliente.empresacertificadora
        if (detalleCliente.archivosgeneralescliente[i].nameid === "DGCP") nameDoc = 'Comprobante de pago'
        if (detalleCliente.archivosgeneralescliente[i].nameid === "DGDO") nameDoc = 'Denominación de origen'
        if (detalleCliente.archivosgeneralescliente[i].nameid === "DGIOV") nameDoc = 'Identificación oficial vigente del solicitante: ' + detalleCliente.nombrerazonsocial

        if (detalleCliente.archivosgeneralescliente[i].nameid === "DGCDF" || detalleCliente.archivosgeneralescliente[i].nameid === "DGRFC" || detalleCliente.archivosgeneralescliente[i].nameid === "DGCP") quitarVigencia = true

        if (nameDoc.length > 0) {

            if (detalleCliente?.archivosgeneralescliente?.[i]?.fechafin !== null) {

                diasFaltantesVencimiento = moment(detalleCliente?.archivosgeneralescliente?.[i]?.fechafin.substring(0, 10)).diff(moment(fechaHoy), 'days')

                if (diasFaltantesVencimiento > 5) {
                    alertaFechaVencimiento = 'verde'
                } else if (diasFaltantesVencimiento > 0 && diasFaltantesVencimiento < 6) {
                    alertaFechaVencimiento = 'amarillo'
                } else if (diasFaltantesVencimiento == 0 || diasFaltantesVencimiento < 0) {
                    alertaFechaVencimiento = 'rojo'
                }
            } else {
                alertaFechaVencimiento = 'gris'
            }

            rowsDocumentacionArchivosGenerales.push({
                id: uuidv4(),
                observacion: detalleCliente?.archivosgeneralescliente?.[i]?.observaciones,
                fechaInicio: detalleCliente?.archivosgeneralescliente?.[i]?.fechainicio !== null ? detalleCliente?.archivosgeneralescliente?.[i]?.fechainicio.substring(0, 10) : '---',
                fechaTermino: detalleCliente?.archivosgeneralescliente?.[i]?.fechafin !== null ? detalleCliente?.archivosgeneralescliente?.[i]?.fechafin.substring(0, 10) : '---',
                estatus: detalleCliente?.archivosgeneralescliente?.[i]?.estatus !== 'null' ? detalleCliente?.archivosgeneralescliente?.[i]?.fechafin : 'Agregar',
                tabla: 'archivosgeneralescliente', nombreId: 'idarchivosgeneralescliente',
                idSolicitud: detalleCliente.archivosgeneralescliente[i].idarchivosgeneralescliente, nameid: detalleCliente?.archivosgeneralescliente?.[i]?.nameid,
                nameDoc: nameDoc, colorAlertaFecha: alertaFechaVencimiento, quitarVigencia: quitarVigencia,
                isDocumentoValido: detalleCliente?.archivosgeneralescliente?.[i]?.isdocumentovalido
            })
        }
    }

    if (rowsDocumentacionArchivosGenerales.length > 1) {
        rowsDocumentacionArchivosGenerales.sort(((a, b) => a.idSolicitud - b.idSolicitud));
    }

    const [openModal, setOpenModal] = React.useState(false);
    const [openModalSustituir, setOpenModalSustituir] = React.useState(false);
    const [dataSustituir, setDataSustituir] = React.useState([]);

    const columnsDocumentacion = [
        {
            field: 'documentoValido', headerName: '', headerAlign: 'center', width: 40, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla &&
                        <Fragment>
                            <BotonDocumentoValidoComponent data={params.row} idcliente={detalleCliente.idcliente} />
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'nameDoc', headerName: '', headerAlign: 'center', width: 430, sortable: false,
            renderCell: (params) =>
            (
                <Fragment>
                    {params.row.tabla ?
                        <div style={{ width: '100%', textAlign: 'left' }}>
                            <label>{`${params.row.nameDoc}`}</label>
                        </div>
                        :
                        <div style={{ width: '100%', padding: '3%' }}>
                            <label className={`${estilos.divisionDocumentacion}`}>{`${params.row.nameDoc}`}</label>
                        </div>
                    }
                </Fragment>
            )
        },
        {
            field: 'fechaTermino', headerName: '', headerAlign: 'center', width: 140, sortable: false,
            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla && params.row.quitarVigencia == true &&
                        <Fragment>
                            <label> Sin vigencia </label>
                        </Fragment>
                    }
                    {params.row.tabla && params.row.quitarVigencia == false &&
                        <Fragment>
                            <label> {`${params.row.fechaTermino}`} </label>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'archivo', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <Fragment>
                            <BotonVerArchivosComponent tabla={params.row?.tabla} nombreId={params.row?.nombreId} idSolicitud={params.row?.idSolicitud} nameid={params.row?.nameid} />
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'historial', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) =>
            (
                <Fragment>
                    {
                        params.row.tabla &&
                        <Fragment>
                            <Tooltip title="Ver historial de cambios"><IconButton size="large" onClick={() => { handleModalHistorial(params) }}> <HistoryRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'estatusfecha', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla && params.row.colorAlertaFecha == 'verde' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Vigente"><IconButton size="large"> <CheckCircleOutlineRoundedIcon fontSize="inherit" style={{ fill: '#8ABE3E' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                    {params.row.tabla && params.row.colorAlertaFecha == 'amarillo' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Próximo a vencer"><IconButton size="large"> <ErrorOutlineRoundedIcon fontSize="inherit" style={{ fill: '#F4D35E' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                    {params.row.tabla && params.row.colorAlertaFecha == 'rojo' && params.row.quitarVigencia == false &&
                        <Fragment>
                            <Tooltip title="Vencido"><IconButton size="large"> <ErrorOutlineRoundedIcon fontSize="inherit" style={{ fill: '#DC3545' }} /> </IconButton></Tooltip>
                        </Fragment>
                    }
                    {/*params.row.tabla && params.row.colorAlertaFecha == 'gris' &&
                        <Fragment>
                            <Tooltip title="Sin fechas asignadas"><IconButton size="large"> <BlockRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                        </Fragment>
                    */}
                </Fragment>
            )
        },
        {
            field: 'accion', headerName: '', headerAlign: 'center', width: 70, sortable: false,

            renderCell: (params) => (
                <Fragment>
                    {params.row.tabla &&
                        <Fragment>
                            {(usuarioCompleto?.[0]?.tipousuario?.idtipousuario != 2 && usuarioCompleto?.[0]?.tipousuario?.idtipousuario!= 1) &&
                                <Tooltip title="Sustituir archivo"><IconButton size="large" onClick={() => sustituir(params)} > <FileUploadRoundedIcon fontSize="inherit" style={{ fill: '#2B2B2B' }} /> </IconButton></Tooltip>
                            }
                        </Fragment>
                    }
                </Fragment>
            )
        },
        {
            field: 'observacion', headerName: '', headerAlign: 'center', width: 300, sortable: false
        },
    ]

    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState([]);
    const [archivo, setArchivo] = React.useState('');

    const handleModalHistorial = async (params) => {
        let data = {}
        if (params.row.tabla === "archivosgeneralescliente") {
            data = { idSolicitud: params.row.idSolicitud, tabla: params.row.tabla }
        } else {
            data = { idSolicitud: params.row.idAnexo, tabla: params.row.tabla }
        }
        let datosObtenidos = await dispatch(obtenerTodoHistorialCliente(data))
        setDataHistorial(datosObtenidos?.payload)
        setArchivo(params?.row?.nameDoc)
        setOpenModalHistorial(true)
    }
    const sustituir = async (params) => {
        setDataSustituir(params.row)
        setOpenModalSustituir(true)
    }

    return (
        <Fragment >
            <div style={{ fontFamily: 'Montserrat', height: '750px', overflowY: 'scroll' }}>
                {rowsDocumentacionGeneral.length > 0 &&
                    <div style={{ margin: 0, padding: 0 }}>
                        <h5 style={{ textAlign: 'center', fontWeight: 'bold', color: '#7D9A47' }} >Documentación general.</h5>
                        <Box sx={{ height: 300, width: '100%', mt: 2 }}>
                            <DataGrid
                                rows={rowsDocumentacionGeneral}
                                columns={columnsDocumentacion}
                                rowsPerPageOptions={[50]}
                                headerHeight={0}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    fontFamily: 'Montserrat',
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#4399A4',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '5px'
                                    },
                                    '& .MuiDataGrid-cell': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    },
                                }}
                            />
                        </Box>
                    </div>
                }
                {rowsDocumentacionApoderadosLegales.length > 0 &&
                    <div style={{ margin: 0, padding: 0 }}>
                        <h5 style={{ textAlign: 'center', fontWeight: 'bold', color: '#7D9A47' }} >Apoderados legales.</h5>
                        <Box sx={{ height: 500, width: '100%', mt: 2 }}>
                            <DataGrid
                                rows={rowsDocumentacionApoderadosLegales}
                                columns={columnsDocumentacion}
                                rowsPerPageOptions={[50]}
                                headerHeight={0}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    fontFamily: 'Montserrat',
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#4399A4',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '5px'
                                    },
                                    '& .MuiDataGrid-cell': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    },
                                }}
                            />
                        </Box>
                    </div>
                }
                {rowsDocumentacionPersonasAutorizadas.length > 0 &&
                    <div style={{ margin: 0, padding: 0 }}>
                        <h5 style={{ textAlign: 'center', fontWeight: 'bold', color: '#7D9A47' }} >Personas autorizadas.</h5>
                        <Box sx={{ height: 500, width: '100%', mt: 2 }}>
                            <DataGrid
                                rows={rowsDocumentacionPersonasAutorizadas}
                                columns={columnsDocumentacion}
                                rowsPerPageOptions={[50]}
                                headerHeight={0}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    fontFamily: 'Montserrat',
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#4399A4',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '5px'
                                    },
                                    '& .MuiDataGrid-cell': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    },
                                }}
                            />
                        </Box>
                    </div>
                }
                {rowsDocumentacionArchivosGenerales.length > 0 &&
                    <div style={{ margin: 0, padding: 0 }}>
                        <h5 style={{ textAlign: 'center', fontWeight: 'bold', color: '#7D9A47' }} >Archivos generales.</h5>
                        <Box sx={{ height: 300, width: '100%', mt: 2 }}>
                            <DataGrid
                                rows={rowsDocumentacionArchivosGenerales}
                                columns={columnsDocumentacion}
                                rowsPerPageOptions={[50]}
                                headerHeight={0}
                                getRowHeight={() => 'auto'}
                                sx={{
                                    boxShadow: 0,
                                    color: 'black',
                                    border: 0,
                                    backgroundColor: 'white',
                                    fontFamily: 'Montserrat',
                                    '& .MuiDataGrid-columnHeaders': {
                                        backgroundColor: '#4399A4',
                                        color: 'white',
                                        fontFamily: 'Montserrat',
                                        fontWeight: 'bold',
                                        height: '5px'
                                    },
                                    '& .MuiDataGrid-cell': {
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                    },
                                }}
                            />
                        </Box>
                    </div>
                }
                {openModalHistorial && <BotonHistorialComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} archivo={archivo} />}
                {openModalSustituir && <BotonSustituirComponent setOpenModalSustituir={setOpenModalSustituir} data={dataSustituir} idcliente={detalleCliente?.idcliente} />}
            </div>
        </Fragment>
    )
}

export default DocumentacionGeneralComponent